<h1>Dashboard</h1>
<bar-loader [loading]="loading$ | async"></bar-loader>

<mat-tab-group #tabs [selectedIndex]="activeTab$ | async" (selectedIndexChange)="tabChange($event)">
  <mat-tab label="Statistics">
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="80px">
      <div fxFlex="1 1 33.33%">
        <div fxLayout="column">
          <div fxFlex>
            <h2>Most Active Users</h2>
            <div fxLayout="column">
              <leaderboard
                [list]="activeMembers$ | async"
                emptyMessage="No active users"
                [headings]="activeUserLabels"
              ></leaderboard>
            </div>
          </div>
          <div fxFlex>
            <h2>Most Active Communities</h2>
            <div fxLayout="column">
              <leaderboard
                [list]="activeCustomers$ | async"
                emptyMessage="No active communities"
                [headings]="activeCustomerLabels"
              ></leaderboard>
            </div>
          </div>
        </div>
      </div>

      <div fxFlex="1 1 33.33%" fxLayout="column">
        <ca-featured-number [value]="checkInCount$ | async" message="Checkins"></ca-featured-number>
        <div fxFlex="0 0 auto">
          <ca-checkin-health
            [totals]="checkInCounts$ | async"
            [dailySummary]="checkInsByDate$ | async"
          ></ca-checkin-health>
        </div>
        <div fxFlex="1 1 auto">
          <h2>Recent Checkins</h2>
          <div class="map-container">
            <agm-map [fitBounds]="true">
              <agm-marker-cluster
                imagePath="/assets/images/clusters/m"
                [styles]="clusterStyles"
                [maxZoom]="12"
              >
                <agm-marker
                  *ngFor="let marker of (mappableCheckIns$ | async)"
                  [agmFitBounds]="true"
                  [latitude]="marker.location.lat"
                  [iconUrl]="{ url: BADGES[marker.score], scaledSize: { width: 30, height: 30 } }"
                  [longitude]="marker.location.lng"
                >
                  <agm-info-window>
                    <h4>
                      {{ (customers$ | async)[marker.customerId] | displayname }}
                    </h4>
                    <a
                      href="http://localhost:8100/#/customers/{{ marker.customerId }}"
                      target="blank"
                      >Open in CareApp</a
                    >
                  </agm-info-window>
                </agm-marker>
              </agm-marker-cluster>
            </agm-map>
          </div>
        </div>
      </div>

      <div fxFlex="1 1 33.33%">
        <div fxLayout="column">
          <div fxFlex>
            <ca-featured-number
              [value]="memoCount$ | async"
              message="Messages"
            ></ca-featured-number>
          </div>
          <div fxFlex>
            <h2>Message Categories</h2>
            <category-list
              [list]="popularCategories$ | async"
              [headings]="popularCategoriesLabels"
            ></category-list>

            <ca-memo-category-graph [data]="popularCategories$ | async"> </ca-memo-category-graph>

            <h2>Message Types</h2>
            <category-list
              [list]="popularTypes$ | async"
              [headings]="popularTypesLabels"
            ></category-list>

            <ca-memo-type-graph [data]="popularTypes$ | async"></ca-memo-type-graph>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Feedback" *hasRole="adminRoles">
    <div fxLayout="row">
      <div fxFlex="0 0 100%">
        <ca-feedback [feedback]="feedback$ | async"></ca-feedback>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Notices">
    <div fxLayout="row">
      <div fxFlex="0 0 50%">
        <ca-announcements [announcements]="announcements$ | async"></ca-announcements>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
